import {
  Calendar,
  Inbox,
  Settings,
  ChartSpline,
  NotepadText,
  Building2,
  Euro,
  Bike,
  Store,
  User as UserIcon,
  Library,
  Waypoints,
  ConciergeBell,
  ClipboardList,
  Shield,
} from 'lucide-react'
import { Permission, Role } from '.'

const reivewItem = {
  title: 'reviews',
  url: '#',
  icon: Inbox,
}

const insightItem = {
  title: 'insights',
  url: '/insights',
  icon: ChartSpline,
  permission: Permission.Reports,
}

const bookingsItem = {
  title: 'bookings',
  url: '/bookings?status=waiting_confirmation',
  icon: NotepadText,
  permission: Permission.BookingsViewAny,
}

const earningsItem = {
  title: 'earnings',
  url: '/earnings',
  icon: Euro,
  permission: Permission.Reports,
}

const shopsItem = {
  title: 'online_stores',
  url: '/online-stores',
  icon: Store,
  permission: Permission.StoresViewAny,
}

const internalExperiencesItem = {
  title: 'internal_experiences',
  url: '/experiences',
  icon: ConciergeBell,
  permission: Permission.ExperiencesViewAny,
}

const externalExperiencesItem = {
  title: 'external_experiences',
  url: '/external-experiences',
  icon: Waypoints,
  permission: Permission.ExternalExperiencesViewAny,
}

const calendarItem = {
  title: 'calendar',
  url: '/calendar',
  icon: Calendar,
  permission: Permission.BookingsViewAny,
}

const settings = {
  title: 'settings',
  url: '/settings',
  icon: Settings,
  permission: Permission.SettingsEditBase,
}

const organizerItem = {
  title: 'organizers',
  url: '/companies/organizer',
  icon: Building2,
  permission: Permission.CompaniesViewAny,
}

const sellerItem = {
  title: 'sellers',
  url: '/companies/seller',
  icon: Building2,
  permission: Permission.CompaniesViewAny,
}

const chainItem = {
  title: 'chains',
  url: '/companies/chain',
  icon: Building2,
  permission: Permission.CompaniesViewAny,
}

const productItem = {
  title: 'products',
  url: '/products',
  icon: Bike,
  permission: Permission.ProductsViewAny,
}

const userItem = {
  title: 'users',
  url: '/users',
  icon: UserIcon,
  permission: Permission.UsersViewAny,
}

const tdlLeadsItem = {
  title: 'TDL Leads',
  url: '/tdl-leads',
  icon: ClipboardList,
  permission: Permission.TdlLeadsViewAny,
}

const rolesItem = {
  title: 'roles_management',
  url: '/roles',
  icon: Shield,
  permission: Permission.RolesViewAny,
}

export const sidebarItems: Record<string, any> = {
  booking: [],
  dashboard: [
    insightItem,
    organizerItem,
    sellerItem,
    chainItem,
    bookingsItem,
    calendarItem,
    earningsItem,
    userItem,
    tdlLeadsItem,
    // rolesItem,
  ],
  experiences: [shopsItem, externalExperiencesItem, internalExperiencesItem],
  resources: [productItem],
  account: [settings],
}
